import { Injectable, inject } from '@angular/core';

import { ComponentStore, tapResponse } from '@ngrx/component-store';
import { Observable, exhaustMap, tap } from 'rxjs';

import { Property } from '@tsq-web/property';

import { PropertyService } from '../../shared/property/property.service';

interface PropertiesStoreState {
  propertiesFetchStatus: 'idle' | 'loading' | 'success' | 'error';
  properties: Property[];
}

const initialState: PropertiesStoreState = {
  propertiesFetchStatus: 'idle',
  properties: [],
};

@Injectable()
export class PropertiesStore extends ComponentStore<PropertiesStoreState> {
  private readonly propertyService = inject(PropertyService);

  readonly properties$ = this.select(({ properties }) => properties);

  readonly fetchPropertiesByCondoId = this.effect((condoId$: Observable<string>) =>
    condoId$.pipe(
      tap(() => this.patchState({ propertiesFetchStatus: 'loading' })),
      exhaustMap(condoId =>
        this.propertyService.getPropertiesPublic(condoId).pipe(
          tapResponse(
            properties => this.patchState({ propertiesFetchStatus: 'success', properties }),
            () => this.patchState({ propertiesFetchStatus: 'error' }),
          ),
        ),
      ),
    ),
  );

  constructor() {
    super(initialState);
  }
}
